<template>
	<div class="global-surface" :style="globalStyle">
		<div class="global-surface__header">
			<div v-if="title" class="global-surface__title" :class="{ 'global-surface__title--margin': button }" :style="(marginTopPx, fontSizePx)">
				{{ title }}
			</div>
			<slot name="header" />
		</div>
		<slot />
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	title?: string
	button?: boolean
	fontSize?: number
	padding?: number | string
	customPadding?: number | string
	border?: number
	borderRadius?: number
	borderColor?: string
}>()

const fontSizePx = computed(() => {
	if (!props.fontSize) return
	const value = `${props.fontSize}px`
	return `font-size: ${value}`
})

const paddingPx = computed(() => {
	if (props.customPadding) {
		if (typeof props.customPadding === 'number') return `padding: ${props.customPadding}px;`
		else return `padding: ${props.customPadding};`
	}
	if (!props.title) return 'padding: 0px;'
	if (!props.padding) return
	const value = typeof props.padding === 'number' ? `${props.padding}px` : props.padding
	return `padding: ${value}; padding-top: 0;`
})

const marginTopPx = computed(() => {
	if (!props.padding) return
	const value = typeof props.padding === 'number' ? `${props.padding}px` : props.padding
	return `margin-top: ${value};`
})

const borderPx = computed(() => {
	if (!props.border && props.border !== 0) return 'box-shadow: inset 0 0 0 1px var(--stroke-on-background);'
	else if (props.borderColor) return `box-shadow: inset 0 0 0 ${props.border}px ${props.borderColor};`
	else return `box-shadow: inset 0 0 0 ${props.border}px var(--stroke-on-background);`
})

const borderRadiusPx = computed(() => {
	if (!props.borderRadius && props.borderRadius !== 0) return 'border-radius: 16px;'
	else return `border-radius: ${props.borderRadius}px;`
})

const globalStyle = computed(() => {
	if (!paddingPx.value) return `${borderPx.value} ${borderRadiusPx.value}`
	return `${paddingPx.value} ${borderPx.value} ${borderRadiusPx.value}`
})
</script>

<style lang="scss">
@import './Surface';
</style>
